import { render, staticRenderFns } from "./burqaa.vue?vue&type=template&id=0d504bf4&scoped=true&"
import script from "./burqaa.vue?vue&type=script&lang=js&"
export * from "./burqaa.vue?vue&type=script&lang=js&"
import style0 from "./burqaa.vue?vue&type=style&index=0&id=0d504bf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d504bf4",
  null
  
)

export default component.exports